"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Toolbox = void 0;
const _ = require("lodash");
class Toolbox {
    stringformat(format, args) {
        var args = arguments[1];
        for (var i = 0; i < args.length; i++) {
            var reg = new RegExp("\\{" + i + "\\}", "gm");
            format = format.replace(reg, args[i]);
        }
        return format;
    }
    createRequestUrl(format, ...args) {
        var encodedArgs = _.map(_.without(arguments, arguments[0]), function (arg) {
            if (!arg) {
                return arg;
            }
            return arg.toString()
                .replace(/#/g, '__HASH__')
                .replace(/%/g, '__PERCENT__');
        });
        return this.stringformat(format, encodedArgs);
    }
    addCacheBuster(url) {
        if (url.indexOf('?') === -1) {
            url += '?';
        }
        else if (url[url.length - 1] !== '&' && url[url.length - 1] !== '?') {
            url += '&';
        }
        url += 'cb=' + new Date().getTime();
        return url;
    }
}
exports.Toolbox = Toolbox;
